import { render } from "./RelateVideos.vue?vue&type=template&id=11111306&scoped=true"
import script from "./RelateVideos.vue?vue&type=script&lang=js"
export * from "./RelateVideos.vue?vue&type=script&lang=js"

import "./RelateVideos.vue?vue&type=style&index=0&id=11111306&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11111306"]])

export default __exports__